export const SHOW_SEARCH_AI_PROMPT = "SHOW_SEARCH_AI_PROMPT";
export const HIDE_SEARCH_AI_PROMPT = "HIDE_SEARCH_AI_PROMPT";
export const SHOW_SEARCH_RESULTS = "SHOW_SEARCH_RESULTS";
export const SET_SEARCH_INPUT_VALUE = "SET_SEARCH_INPUT_VALUE";
export const SEARCH_LOADING = "SEARCH_LOADING";
export const SET_SEARCH_AI_STOPS = "SET_SEARCH_AI_STOPS";
export const SET_STOP_LABELS = "SET_STOP_LABELS";

interface ActionTypes {
  SHOW_SEARCH_AI_PROMPT: boolean;
  HIDE_SEARCH_AI_PROMPT: boolean;
  SHOW_SEARCH_RESULTS: boolean;
  SET_SEARCH_INPUT_VALUE: string;
  SEARCH_LOADING: boolean;
  SET_SEARCH_AI_STOPS: any;
  SET_STOP_LABELS: any;
}

export interface MessageAction {
  type: keyof ActionTypes;
  payload: any;
}

export const setShowSearchAIPrompt = () => ({
  type: SHOW_SEARCH_AI_PROMPT,
});

export const setHideSearchAIPrompt = () => ({
  type: HIDE_SEARCH_AI_PROMPT,
});

export const setShowSearchResults = () => ({
  type: SHOW_SEARCH_RESULTS,
});

export const setSearchInputValue = (value: string) => ({
  type: SET_SEARCH_INPUT_VALUE,
  payload: value,
});

export const setSearchLoading = (loading: boolean) => ({
  type: SEARCH_LOADING,
  payload: loading,
});

export const setSearchStops = (stops: any) => ({
  type: SET_SEARCH_AI_STOPS,
  payload: stops,
});

export const setStopLabels = (labels: any) => ({
  type: SET_STOP_LABELS,
  payload: labels,
});

export type SearchAIActionTypes = MessageAction;
